import React from "react";
import { Button } from "@mui/material";
import { theme } from "../../Assets/Theme/theme";

const SelectableButton = ({ label, selected, onClick }) => {
  return (
    <Button
      onClick={onClick}
      sx={{
        textTransform: "none",
        fontWeight: "400",
        fontSize: "16px",
        borderRadius: "8px",
        padding: "8px 16px",
        border: `1px solid ${theme.colors.orange}`,
        backgroundColor: selected ? theme.colors.orange : "#fff",
        color: selected ? "#fff" : theme.colors.text,
        width: "fit-content",
        "&:hover": {
          backgroundColor: selected
            ? theme.colors.orange
            : "rgba(255, 121, 0, 0.1)",
        },
      }}
    >
      {label}
    </Button>
  );
};
export default SelectableButton;
